import { app } from "../../../bootstrap/core";
import { faqComponent } from "./faq.component";
import { faqUrls } from "./faq.constants";
import "../modals/faq.tpl.html";

app.component("faq", faqComponent);
app.constant("faqUrls", faqUrls);



// WEBPACK FOOTER //
// ./src/app/common/ui/faq/faq.js